window.addEventListener("unhandledrejection", (e) => {
  console.error('[Unhandled Rejection]', e.reason)
}, false)

import { render } from 'solid-js/web'
import { lazy } from 'solid-js'
import 'flatpickr/dist/flatpickr.min.css';
import './index.css'
import '@/styles/components/form-field.scss'
import account from '@lib/auth/account'

import dayjs from "dayjs"
import UTC from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'
import LocalizedFormat from "dayjs/plugin/localizedFormat"

const App = lazy(() => import('./App.jsx'))
const Login = lazy(() => import('./Login.jsx'))

dayjs.extend(UTC)
dayjs.extend(Timezone)
dayjs.extend(LocalizedFormat)

const root = document.getElementById('root')

render(() => (
  <>
    {account().username
      ? <App />
      : <Login />
    }
  </>
), root)
